import PropTypes from 'prop-types';
import { invoiceStatuses } from '../constants/statuses';

export const invoicePropType = PropTypes.shape({
    productName: PropTypes.string.isRequired,
    invoiceNumber: PropTypes.string.isRequired,
    invoiceDate: PropTypes.string.isRequired,
    orderId: PropTypes.string,
    status: PropTypes.oneOf([
        invoiceStatuses.FAILED,
        invoiceStatuses.PAID,
        invoiceStatuses.TO_BE_CHARGED,
        invoiceStatuses.UNPAID,
    ]).isRequired,
    total: PropTypes.shape({
        currency: PropTypes.string.isRequired,
        amount: PropTypes.number.isRequired,
    }).isRequired,
    taxRate: PropTypes.number.isRequired,
    payment: PropTypes.shape({
        paymentMethod: PropTypes.shape({
            text: PropTypes.string,
        }),
        paymentIconType: PropTypes.string,
        source: PropTypes.string,
        paymentDetail: PropTypes.string,
        type: PropTypes.string,
    }),
    invoiceItems: PropTypes.arrayOf(PropTypes.shape({
        quantity: PropTypes.number.isRequired,
        chargeName: PropTypes.string.isRequired,
        productName: PropTypes.string.isRequired,
        chargeAmount: PropTypes.shape({
            currency: PropTypes.string.isRequired,
            amount: PropTypes.number.isRequired,
        }).isRequired,
        taxAmount: PropTypes.shape({
            currency: PropTypes.string.isRequired,
            amount: PropTypes.number.isRequired,
        }).isRequired,
        serviceStartDate: PropTypes.string.isRequired,
        serviceEndDate: PropTypes.string.isRequired,
    })).isRequired,
    customerData: PropTypes.shape({
        firstName: PropTypes.string,
        lastName: PropTypes.string,
        invoiceAddress: PropTypes.shape({
            street: PropTypes.string,
            postalCode: PropTypes.string,
            locality: PropTypes.string,
        }),
    }),
    filePath: PropTypes.string.isRequired,
});
